import { Navigate, Outlet, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Box, CircularProgress } from '@mui/material';

import useAuth from './useAuth';
import { PATH_AFTER_LOGIN, ROLES } from '../config';

// Wrapper de rutas protegidas: exige sesion iniciada y, opcionalmente,
// que el rol del usuario este dentro de `allowedRoles`.
export default function RequireAuth({ allowedRoles }) {
  const { isAuthenticated, isInitialized, role } = useAuth();
  const location = useLocation();

  if (!isInitialized) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (allowedRoles && allowedRoles.length > 0 && !allowedRoles.includes(role)) {
    // El distribuidor no sale de su lista de precios: ni siquiera ve la pagina 403.
    if (role === ROLES.DISTRIBUIDOR) {
      return <Navigate to={PATH_AFTER_LOGIN[ROLES.DISTRIBUIDOR]} replace />;
    }
    return <Navigate to="/403" replace />;
  }

  return <Outlet />;
}

RequireAuth.propTypes = {
  allowedRoles: PropTypes.arrayOf(PropTypes.string),
};
